import React from "react";
import { Box } from "@mui/material";
import { SideProfileButton } from "../SideProfileButton";

export type SidebarProfileSectionProps = {
  name: string;
  profileMode?: "off" | "on" | "disabled";
};

export function SidebarProfileSection({
  name,
  profileMode = "off",
}: SidebarProfileSectionProps) {
  return (
    <Box sx={{ padding: "16px 12px" }}>
      <SideProfileButton name={name} mode={profileMode} />
    </Box>
  );
}
